<template>
  <div class="contact-component" :class="{ ['contact-component--cancelled']: hasCancelled }">
    <ExtraBtnColumn
      v-if="phone"
      flat
      color="secondary"
      text-color="white"
      icon="icon-f-message-square"
      no-caps
      :disabled="hasCancelled"
      :label="$t('ETAB.BUTTONS.@SMS')"
      @click="contact(CONTACT_TYPES.SMS)"
    />
    <ExtraBtnColumn
      v-if="phone"
      flat
      color="secondary"
      text-color="white"
      icon="icon-f-phone-call"
      no-caps
      :disabled="hasCancelled"
      :label="$t('ETAB.BUTTONS.@CALL_PHONE')"
      @click="contact(CONTACT_TYPES.PHONE)"
    />
    <ExtraBtnColumn
      v-if="email"
      flat
      color="secondary"
      text-color="white"
      icon="icon-f-mail"
      no-caps
      :disabled="hasCancelled"
      :label="$t('ETAB.BUTTONS.@EMAIL')"
      @click="contact(CONTACT_TYPES.EMAIL)"
    />
    <QBtn
      v-if="!email && !phone"
      flat
      color="secondary"
      text-color="white"
      icon="icon-f-phone-off"
      no-caps
      :label="$t('ETAB.BUTTONS.@NO_CONTACT_INFORMATION')"
    />
  </div>
</template>

<script>
  import { CONTACT_TYPES } from "@core/constants";
  import { NativeCommunicationManager } from "@core/managers/native-communication.manager";

  export default {
    props: {
      phone: {
        type: String,
        default: null,
      },
      email: {
        type: String,
        default: null,
      },
      hasCancelled: {
        type: Boolean,
        default: false,
      },
    },
    created() {
      this.CONTACT_TYPES = CONTACT_TYPES;
    },
    methods: {
      contact(type) {
        switch (type) {
          case CONTACT_TYPES.SMS: {
            NativeCommunicationManager.sms({ phone: this.phone });
            break;
          }
          case CONTACT_TYPES.PHONE: {
            NativeCommunicationManager.phone({ phone: this.phone });
            break;
          }
          case CONTACT_TYPES.EMAIL: {
            NativeCommunicationManager.sendEmail({ to: this.email });
            break;
          }
          default: {
            break;
          }
        }
      },
    },
  };
</script>

<style lang="scss">
  .contact-component {
    display: flex;
    background: $primary;
    box-shadow: $soft-shadow;

    &--cancelled {
      background: $grey;
    }

    > * {
      flex: 1;
    }
  }
</style>
